import React, {useEffect} from 'react';
import {withRouter, Switch, Redirect} from 'react-router-dom';
import {Auth} from 'aws-amplify';
import {withData} from './containers/DataContainer';

import AppliedRoute from './routes/AppliedRoute'
import AdminLayout from './layouts/AdminLayout'
import UserLayout from './layouts/UserLayout'
import './App.css';

const App = ({data, setUser, authState}) => {

  useEffect(
    () => {
      async function _setUser() {
        try {
          const user = await Auth.currentAuthenticatedUser();
          setUser(user.attributes);
        } catch (e) {
          console.log(e);
        }
      }
      _setUser();
    }, [setUser, authState]
  );

  if (authState === 'signedIn') {
    switch (data.user['custom:type']) {
      case 'admin': return <Switch>
        <AppliedRoute path="/admin" component={AdminLayout}/>
        <Redirect from="/" to="/admin/vehicles" />
      </Switch>;
      case 'user': return <Switch>
        <AppliedRoute path="/user" component={UserLayout}/>
        <Redirect from="/" to="/user/vehicles" />
      </Switch>;
      default: return null;
    }
  } else return null;
};

export default withRouter(withData(App));

  // if (authState === 'signedIn') return (
  //   <Switch>
  //     <AppliedRoute path="/admin" component={AdminLayout}/>
  //     <Redirect from="/" to="/admin/vehicles" />
  //   </Switch>
  // )
  // else return null;


// if (authState === 'signedIn') {
//   if (data.user['custom:type'] === 'admin') {
//     return (
//       <Switch>
//         <AppliedRoute path="/admin" component={AdminLayout}/>
//         <Redirect from="/" to="/admin/overview" />
//       </Switch>
//     )
//   } else if (data.user['custom:type'] === 'user') {
//     return (
//       <Switch>
//         <AppliedRoute path="/user" component={UserLayout}/>
//         <Redirect from="/" to="/user/queue" />
//       </Switch>
//     )
//   } else {
//     return (
//       <Grid container justify="center" alignItems="center"><CircularProgress/></Grid>
//     )
//   }
// } else return null;
